<template>
  <div>
    <!--UPLOAD-->
    <form novalidate>
      <h2 class="block__title">แนบสลิปการโอน</h2>
      <div class="text-remark mb-15">อนุญาตไฟล์นามสกุล .jpg, .png, .jpeg</div>

      <div class="dropbox">
        <input type="file" :disabled="isSaving" ref="fileInput"
          @change="filesChange($event.target.files)"
          accept="image/*" class="input-file">

        <div class="dropbox-upload" v-if="isInitial">
          กดเพื่อเลือกไฟล์ หรือ<br>ลากไฟล์มาวาง
        </div>

        <div class="dropbox-upload" v-if="isSaving">
          <div class='progress-bar'>
            <div class="-inner"></div>
          </div>
        </div>

        <div v-if="uploadedUrl" class="-success">
          <img ref="preview" :src="uploadedUrl" class="img-responsive img-thumbnail">
        </div>
        <div v-if="isSuccess" class="_clearfix">
          <button class="btn btn--purple btn--center mb-20" href="javascript:void(0)" @click.prevent="reset()">อัพโหลดใหม่อีกครั้ง</button>
        </div>
      </div>

    </form>
    <!--SUCCESS-->

  </div>
</template>

<script>
  import Vue from 'vue'
  const Pica = require('../../node_modules/pica/dist/pica.min')

  /**
   * @see: https://github.com/brion/min-wasm-fail/blob/master/min-wasm-fail.js
   * @see: https://support.scandit.com/hc/en-us/articles/115003947711-Known-issues-with-mobile-Safari-on-iOS-11-2-2-and-11-2-5
   */
  function testSafariWebAssemblyBug () {
    let bin = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 6, 1, 96, 1, 127, 1, 127, 3, 2, 1, 0, 5, 3, 1, 0, 1, 7, 8, 1, 4, 116, 101, 115, 116, 0, 0, 10, 16, 1, 14, 0, 32, 0, 65, 1, 54, 2, 0, 32, 0, 40, 2, 0, 11])
    let mod = new window.WebAssembly.Module(bin)
    let inst = new window.WebAssembly.Instance(mod, {})

    // test storing to and loading from a non-zero location via a parameter.
    // Safari on iOS 11.2.5 returns 0 unexpectedly at non-zero locations
    return (inst.exports.test(4) !== 0)
  }

  let pica = null
  if (window.WebAssembly && testSafariWebAssemblyBug()) {
    pica = Pica({ features: [ 'js', 'wasm', 'ww', 'cib' ] })
  } else {
    pica = Pica({ features: [ 'js', 'cib', 'ww' ] })
  }

  const MAX_WIDTH = 1024
  const MAX_HEIGHT = 1024

  const UPLOAD_RETRY_LIMIT = 3
  const UPLOAD_RETRY_WAIT = 2500

  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    name: 'UploadPicker',
    props: {
      orderId: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        uploadedUrl: null,
        currentStatus: null
      }
    },
    computed: {
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess () {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed () {
        return this.currentStatus === STATUS_FAILED
      }
    },
    methods: {
      reset () {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL
        this.uploadedUrl = null
        this.$refs.fileInput.value = ''
      },
      errorHandler (xhr) {
        this.currentStatus = STATUS_FAILED

        this.reset()
        this.$modal.show({
          title: 'ผิดพลาด',
          text: `ไม่สามารถอัพโหลดหลักฐานการโอนเงินได้ กรุณาลองอีกครั้ง หรือส่งรูปหลักฐานการโอนเงิน ไปที่ tcfe@ktf.premier.co.th`,
          ok: () => {
            window.open(`mailto:${Vue.config.WEBSITE_EMAIL}?subject=แจ้งปัญหาไม่สามารถอัพโหลดหลักฐานการโอนเงินได้ (${this.orderId})&body=กรุณากรอกข้อมูลต่อไปนี้ให้ครบถ้วน พร้อมแนบหลักฐานการโอนเงิน%0D%0A%0D%0Aเลขที่การบริจาค: ${this.orderId}%0D%0Aโอนจากธนาคาร: %0D%0Aจำนวนเงินที่โอน (บาท): %0D%0Aวันที่โอน: %0D%0Aเวลาที่โอน ( เช่น 14:50 ): %0D%0A%0D%0A--------------------------------------%0D%0Aขอบคุณสำหรับข้อมูล ทางเจ้าหน้าที่จะตรวจสอบข้อมูล หากคุณไม่ได้รับ Email ขอบคุณที่บริจาคเงินภายใน 7 วัน กรุณาติดต่อ 02 301 1117 หรือ line ID @tcfe`)
          },
          okButtonText: 'ส่่งอีเมล',
          cancelButton: true
        })
      },
      resizeImage (imageUrl, mimetype) {
        return new Promise((resolve) => {
          let newImage = new window.Image()

          newImage.src = imageUrl
          newImage.addEventListener('load', () => {
            const canvas = document.createElement('canvas')

            let width = newImage.naturalWidth
            let height = newImage.naturalHeight

            let toWidth, toHeight
            if (MAX_WIDTH < width) {
              toWidth = MAX_WIDTH
              toHeight = (MAX_WIDTH / width) * height
            } else if (MAX_HEIGHT < height) {
              toHeight = MAX_HEIGHT
              toWidth = (MAX_HEIGHT / height) * width
            } else {
              resolve({
                resized: false
              })
            }

            canvas.width = toWidth
            canvas.height = toHeight

            pica.resize(newImage, canvas)
              .then(result => {
                return pica.toBlob(canvas, mimetype)
              })
              .then(blob => {
                let newFile = null
                try {
                  newFile = new window.File([blob], '')
                } catch (e) {
                  newFile = new window.Blob([blob], { type: mimetype })
                }
                resolve({
                  resized: true,
                  newFile: newFile
                })
              })
              .catch(err => {
                console.log(err)
                resolve({
                  resized: false
                })
              })
          })
        })
      },
      uploadToS3 (file, mimetype, presignedUrl, viewUrl) {
        let retryLimit = UPLOAD_RETRY_LIMIT

        let retry = (ev) => {
          console.log(new Error(`[Error][UploadPicker] (${retryLimit}/${UPLOAD_RETRY_LIMIT}): Status: ${ev.target.status} Text: ${ev.target.statusText} ReadyState: ${ev.target.readyState}`))
          if (retryLimit > 0) {
            setTimeout(() => {
              startUpload()
            }, UPLOAD_RETRY_WAIT)
          } else {
            this.errorHandler(ev.target)
          }
        }

        let startUpload = () => {
          retryLimit--

          const oReq = new window.XMLHttpRequest()
          oReq.addEventListener('load', ev => {
            if (ev.target.status === 200) {
              this.currentStatus = STATUS_SUCCESS
              this.$emit('uploaded', viewUrl.replace(/\?.*/, ''))
            } else {
              retry(ev)
            }
          })

          oReq.addEventListener('error', ev => {
            retry(ev)
          })

          oReq.open('PUT', presignedUrl, true)
          oReq.setRequestHeader('Content-Type', mimetype)
          oReq.send(file)
        }

        startUpload()
      },
      save (file) {
        this.currentStatus = STATUS_SAVING

        const reader = new window.FileReader()
        reader.addEventListener('load', () => {
          this.uploadedUrl = reader.result

          this.resizeImage(reader.result, file.type)
            .then(result => {
              let resizedFile = file
              if (result.resized) {
                resizedFile = result.newFile
              }

              return this.$http.get('storage/presigned-url', { params: { mimetype: file.type } })
                .then(resp => {
                  const presignedUrl = resp.body.presignedUrl
                  const viewUrl = resp.body.url

                  this.uploadToS3(resizedFile, file.type, presignedUrl, viewUrl)
                })
            })
            .catch(err => {
              console.log(err)

              this.currentStatus = STATUS_FAILED
              this.reset()
              this.$modal.show({
                title: 'ผิดพลาด',
                text: 'ไม่สามารถ upload ไฟล์ได้ กรุณาลองใหม่อีกครั้ง'
              })
            })
        }, false)
        reader.readAsDataURL(file)
      },
      filesChange (fileList) {
        if (!fileList.length) return
        let img = fileList[0]
        let allowedTypes = ['image/jpg', 'image/jpeg', 'image/png']
        if (allowedTypes.indexOf(img.type) === -1) {
          this.$modal.show({
            title: 'ผิดพลาด',
            text: `ไม่สามารถ upload ไฟล์ประเภท ${img.type.replace(/image\//, '')} ได้ กรุณาเลือกไฟล์ใหม่`
          })
          return
        }
        this.save(fileList[0])
      }
    },
    mounted () {
      this.reset()
    }
  }

</script>

<style lang="scss">
  .dropbox {
    font-family: 'kanit', sans-serif;
    outline: 2px dashed #fff; /* the dash box */
    outline-offset: -5px;
    background: #C6E5F4;
    min-height: 150px; /* minimum height */
    position: relative;
    cursor: pointer;
    margin-bottom: 12px;

    &:hover {
      background: #D6EBF5; /* when mouse over to the drop zone, change color */
    }

    & > .dropbox-upload {
      pointer-events: none;
      font-size: 1.2em;
      font-weight: 300;
      text-align: center;
      margin: 0 0 12px 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;

      & button {
        display: inline;
      }

      &.-success {
        position: static;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 10px 20px;
        transform: none;
      }
    }
  }

  progress {
    border: 1px solid black;
  }

  progress::-webkit-progress-bar {
    background-color: #f80;
    width: 100%;
  }
  progress::-webkit-progress-value {
    background-color: #0ff !important;
  }

  .input-file {
    opacity: 0.000001;
    z-index: 9;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
  }

  .list-unstyled {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .img-responsive {
    max-width: 100%;
    height: auto;
  }

  .progress-bar {
    background-color: #f2efef;
    width: 80%;
    height: 24px;
    margin: 0 auto;
    border-radius: 12px;

    .-inner {
      background: linear-gradient(
          135deg,
          #C6E5F4 25%, #80C6E9 25%,
          #80C6E9 50%, #C6E5F4 50%,
          #C6E5F4 75%, #80C6E9 75%
      );

      width: 100%;
      height: 24px;
      border-radius: 12px;
      background-size: 50px 50px;
      animation: bar-animation 3s linear infinite;
    }
  }

  @keyframes bar-animation {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 50px 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// UploadPicker.vue?9dd29cfe